<section class="team row">
  <button *ngFor="let t of team.slice(0, count); let i = index"
     class="col-xs-12 col-sm-6 col-md-6 col-lg-4 team-member"
     [class.disabled]="isDisabled(i) && this.order !== null"
     role="button"
     [attr.aria-expanded]="!isDisabled(i)"
     id="{{t.id}}"
     routerLink="/about"
     [fragment]="t.id"
     attr.aria-controls="team-bio"
     attr.aria-label="{{t.name}} bio"
     (click)="showBio(findBio(t.id))"
     >
    <div class="box">
      <picture>
        <source srcset="/assets/images/team/{{t.id}}.webp">
        <img loading="lazy" src="/assets/images/team/{{t.id}}.jpg" alt="Photo of {{t.name}}"/>
      </picture>
      <header>
        <span class="name">{{t.name}}</span>
        <span class="title" *ngIf="t.title">{{t.title}}</span>
      </header>
    </div>
  </button>
  <div
    id="team-bio"
    *ngIf="order !== null && team[order]"
    class="faq col-xs-12 col-sm-12 col-md-12 col-lg-12"
    style="order: {{order}}"
    aria-live="polite"
    attr.aria-hidden="{{order ===null ? true : false}}"
    >
    <button
      aria-label="Close Team Member Bio"
      aria-expanded="true"
      (click)="closeBio()">
      <mat-icon>close</mat-icon>
    </button>
    <ng-container *ngIf="team[order].faq.length > 0">
      <p *ngFor="let faq of team[order].faq">
        <strong>{{faq.q}}</strong> {{faq.a}}
      </p>
    </ng-container>
    <ng-container *ngIf="!team[order].faq.length">
      <p>
        Bio not found. Please check back soon.
      </p>
    </ng-container>

  </div>
</section>
